import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {Filter, LawyerFilter, LawyerSettings} from './filter';
import {AbstractPaginatedList} from '../abstract-paginated-list';

/**
 * Lawyer list.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class List extends AbstractPaginatedList<LawyerFilter, LawyerSettings> {
  constructor(container: HTMLElement) {
    super(container);

    ComponentRegistry.wait<Filter>('lawyer-filter')
      .then(filterPlugin => {
        this.find(filterPlugin.filter);
        filterPlugin.emitter.on('change', () => {
          this.pagination.browse(0);
        });
        this.pagination.emitter.on('browse', paginationSettings => {
          this.settings.start = paginationSettings.start;
          this.find(filterPlugin.filter);
        });
      });

    ComponentRegistry.add('lawyer-list', this);
  }

  /**
   * Finds lawyers.
   *
   * @param {LawyerFilter} filter Filter
   */
  protected find(filter: LawyerFilter | null): void {
    filter = AbstractFilter.isFilterEmpty<LawyerFilter>(filter) ? null : filter;
    DataApi.instance.lawyerEndpoint.find(this.settings, filter)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/lawyer/item.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++,
            itemClass: 'col-12 col-md-4 mb-xl-5',
            linkClass: 'img-grayscale',
            hidePosition: false
          });
        }
        this.update(html);

        this.pagination.settings.numFound = response.numFound;
        this.pagination.update();

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
